import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { BLOG_CATEGORIES, categorySlug } from "../lib/blogCategories";

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  } catch {
    return "";
  }
};

const chipCls = (active) =>
  `inline-block font-mono text-[10px] tracking-[0.18em] uppercase px-4 py-2.5 border transition-colors ${
    active
      ? "bg-[#2C5F3A] text-[#EFEBDE] border-[#2C5F3A]"
      : "border-[#16281C]/20 text-[#4C5C50] hover:border-[#2C5F3A] hover:text-[#2C5F3A]"
  }`;

export const CategoryChips = ({ active }) => (
  <div data-testid="category-chips" className="mt-10 flex flex-wrap gap-2.5">
    <Link to="/blog" data-testid="chip-all" className={chipCls(!active)}>
      All Topics
    </Link>
    {BLOG_CATEGORIES.map((c) => (
      <Link key={c} to={`/blog/category/${categorySlug(c)}`} data-testid={`chip-${categorySlug(c)}`} className={chipCls(active === c)}>
        {c}
      </Link>
    ))}
  </div>
);

export const PostCard = ({ p, i = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
  >
    <Link
      to={`/blog/${p.slug}`}
      data-testid="blog-card"
      className="group flex flex-col h-full bg-[#FAF8F1] border border-[#16281C]/12 hover:border-[#2C5F3A]/40 transition-colors overflow-hidden"
    >
      <div className="aspect-[16/10] overflow-hidden bg-[#DDE4D5]">
        {p.cover_image ? (
          <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#2C5F3A] to-[#16281C]" />
        )}
      </div>
      <div className="p-7 flex flex-col flex-1">
        {(p.category || p.tags?.[0]) && (
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#2C5F3A] mb-3">{p.category || p.tags[0]}</span>
        )}
        <h2 className="font-display font-semibold text-xl md:text-2xl tracking-tight text-[#16281C] leading-tight group-hover:text-[#2C5F3A] transition-colors">
          {p.title}
        </h2>
        {p.excerpt && <p className="mt-3 font-body text-sm text-[#66766A] leading-relaxed line-clamp-3">{p.excerpt}</p>}
        <div className="mt-auto pt-6 flex items-center justify-between font-mono text-[10px] tracking-[0.15em] uppercase text-[#8B978C]">
          <span>{fmtDate(p.published_at)}</span>
          <span className="inline-flex items-center gap-1.5"><Clock size={12} /> {p.read_time} min</span>
        </div>
      </div>
    </Link>
  </motion.div>
);
